import { useEffect } from "react";

const FOCUSABLE =
  'a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';

// Escape closes, focus moves into the container, Tab stays inside it,
// and focus returns to whatever opened it when it closes.
export default function useModal(open, onClose, containerRef) {
  useEffect(() => {
    if (!open) return undefined;
    const previouslyFocused = document.activeElement;
    const container = containerRef.current;
    if (container) {
      const first = container.querySelector("[data-autofocus]") || container;
      first.focus();
    }

    const onKeyDown = (e) => {
      if (e.key === "Escape") {
        e.stopPropagation();
        onClose();
        return;
      }
      if (e.key !== "Tab" || !containerRef.current) return;
      const nodes = containerRef.current.querySelectorAll(FOCUSABLE);
      if (nodes.length === 0) return;
      const firstNode = nodes[0];
      const lastNode = nodes[nodes.length - 1];
      if (e.shiftKey && document.activeElement === firstNode) {
        e.preventDefault();
        lastNode.focus();
      } else if (!e.shiftKey && document.activeElement === lastNode) {
        e.preventDefault();
        firstNode.focus();
      }
    };

    document.addEventListener("keydown", onKeyDown);
    return () => {
      document.removeEventListener("keydown", onKeyDown);
      if (previouslyFocused && previouslyFocused.focus) previouslyFocused.focus();
    };
  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
}
